import React from 'react';
import { CmsBrowsePage } from 'js/model/cms/cms-browse-page';
import { VenueListingSpecificationOutput } from 'js/model/rainbow/browse-page/VenueListingSpecificationOutput';
import { generateBrowseTitle } from 'js/model/view/browse-page/browse-meta';
import { PaginationOutput } from 'js/model/rainbow/PaginationOutput';
import { urlContext, UrlWithTreatwell } from 'js/components/url';

export type CmsPageTitle = {
  'page-head': {
    'title-template': string;
  };
};
interface Props {
  cms: CmsBrowsePage & CmsPageTitle;
  specification: VenueListingSpecificationOutput;
  pagination: PaginationOutput;
}

export class BrowseTitle extends React.Component<Props> {
  public static contextType = urlContext;

  public componentDidMount(): void {
    this.updateTitle();
  }

  public componentDidUpdate(): void {
    this.updateTitle();
  }

  private updateTitle(): void {
    const url = this.context as UrlWithTreatwell;

    const titleOverride = url.query.titleoverride;
    const browseTitle = generateBrowseTitle(
      this.props.cms,
      this.props.specification,
      this.props.pagination,
      titleOverride
    );
    document.title = this.props.cms['page-head']['title-template'].replace(
      '{page-title}',
      browseTitle
    );
  }

  public render(): React.ReactNode {
    return null;
  }
}
